import { render, staticRenderFns } from "./activityAlbum.vue?vue&type=template&id=557fbd74&scoped=true"
import script from "./activityAlbum.vue?vue&type=script&lang=js"
export * from "./activityAlbum.vue?vue&type=script&lang=js"
import style0 from "./activityAlbum.vue?vue&type=style&index=0&id=557fbd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fbd74",
  null
  
)

export default component.exports